export default "__VITE_ASSET__ff7cf522__"